import { ManageEmployeesEnds, ManageTeamEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(ManageTeamEnds.CREATE, data, true, {}, {}, axios);

const getAll = async (queryString: string): Promise<any> =>
  APIManager.sendGet(ManageTeamEnds.GET_ALL(queryString), true, {}, {}, axios);

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(ManageEmployeesEnds.UPDATE(id), data, true, {}, {}, axios);

const detail = async (id: string): Promise<any> =>
  APIManager.sendGet(ManageEmployeesEnds.DETAIL(id), true, {}, {}, axios);

const deleteRecord = async (id: string): Promise<any> =>
  APIManager.sendDelete(ManageEmployeesEnds.DELETE(id), true, {}, {}, axios);

const teamMembers = async (queryString: string): Promise<any> =>
  APIManager.sendGet(
    ManageTeamEnds.TEAM_MEMBERS(queryString),
    true,
    {},
    {},
    axios
  );

const deleteTeamMember = async (memberUserId: string): Promise<any> =>
  APIManager.sendDelete(
    ManageTeamEnds.DELETE_TEAM_MEMBER(memberUserId),
    true,
    {},
    {},
    axios
  );

const getAuditorGovernanceReviewers = async (
  queryString: string
): Promise<any> =>
  APIManager.sendGet(
    ManageTeamEnds.TEAM_MEMBERS_AUDITOR_GOVERNANCE_REVIEWER(queryString),
    true,
    {},
    {},
    axios
  );

export const ManageTeamService = {
  create,
  getAll,
  update,
  detail,
  deleteRecord,
  teamMembers,
  deleteTeamMember,
  getAuditorGovernanceReviewers,
};
